import { render, staticRenderFns } from "./eventCloseClassify.vue?vue&type=template&id=5ad8271a&scoped=true&"
import script from "./eventCloseClassify.vue?vue&type=script&lang=js&"
export * from "./eventCloseClassify.vue?vue&type=script&lang=js&"
import style0 from "./eventCloseClassify.vue?vue&type=style&index=0&id=5ad8271a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8271a",
  null
  
)

export default component.exports